import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRevenueCodeLookup extends Layout {
    sourceRevenueCodeLookup: DataSource;
    tableRevenueCodeLookup: Table;
}
